(function () {
	if (!window.PVTEST || !PVTEST.ajaxUrl) return;

	var postId = Number(PVTEST.postId || 0);
	if (!postId) {
		var m = document.body.className.match(/postid-(\d+)/);
		if (m && m[1]) postId = Number(m[1]);
	}
	if (!postId) return;

	function ping() {
		var fd = new FormData();
		fd.append("action", "pv_test_ping");
		fd.append("post_id", String(postId));

		fetch(PVTEST.ajaxUrl, {
			method: "POST",
			body: fd,
			credentials: "same-origin",
		})
			.then((r) => r.json())
			.then((data) => {
				if (data?.success && typeof data.data?.views !== "undefined") {
					var el = document.querySelector(
						'.js-views[data-post-id="' + postId + '"]'
					);
					if (el) el.textContent = String(data.data.views);
				}
			})
			.catch(console.error);
	}

	if (document.readyState === "loading")
		document.addEventListener("DOMContentLoaded", ping);
	else ping();
})();
